module.exports = __webpack_public_path__ + "static/header-photo-880d4efc12b61bf9b1777bb8c9c4f0cd.jpg";